import * as types from './creditIncentiveTypes'

const initialState = {
  isCrediting: false,
  incentive: null,
  timeSlotId: null,
  currency: null,
  bulkIncentiveModeEnabled: false,
  selectedTimeSlotIds: []
}

const creditIncentiveReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CREDIT_INCENTIVE_REQUESTED:
      return { ...state, isCrediting: true, isCreditingSuccessful: false }
    case types.CREDIT_INCENTIVE_SUCCEEDED:
      return { ...state, isCrediting: false, isCreditingSuccessful: true, bulkIncentiveModeEnabled: false, selectedTimeSlotIds: [] }
    case types.CREDIT_INCENTIVE_FAILED:
      return { ...state, isCrediting: false, isCreditingSuccessful: false }
    case types.RESET_CREDIT_INCENTIVE_STATE:
      return {
        ...state,
        isCreditingSuccessful: false,
        bulkIncentiveModeEnabled: false
      }
    case types.BULK_INCENTIVE_MODE_ENABLED:
      return {
        ...state,
        bulkIncentiveModeEnabled: true
      }
    case types.BULK_INCENTIVE_MODE_DISABLED:
      return {
        ...state,
        bulkIncentiveModeEnabled: false,
        selectedTimeSlotIds: []
      }
    case types.SET_BULK_SELECTED_TIME_SLOTS:
      return {
        ...state,
        selectedTimeSlotIds: action.payload
      }
    default:
      return state
  }
}

export default creditIncentiveReducer
